"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentPreviewApi = void 0;
const axios_1 = require("axios");
const globalImportUrl = require("url");
const base_1 = require("../base");
function ContentPreviewApiAxiosParamCreator(configuration) {
    return {
        getContentPreview(contentId, version, options = {}) {
            if (contentId === null || contentId === undefined) {
                throw new base_1.RequiredError("contentId", "Required parameter contentId was null or undefined when calling getContentPreview.");
            }
            if (version === null || version === undefined) {
                throw new base_1.RequiredError("version", "Required parameter version was null or undefined when calling getContentPreview.");
            }
            const localVarPath = `/content/preview/{contentId}/{version}`
                .replace(`{${"contentId"}}`, encodeURIComponent(String(contentId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
}
function ContentPreviewApiFp(configuration) {
    return {
        getContentPreview(contentId, version, options) {
            const localVarAxiosArgs = ContentPreviewApiAxiosParamCreator(configuration).getContentPreview(contentId, version, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
}
class ContentPreviewApi extends base_1.BaseAPI {
    getContentPreview(contentId, version, options) {
        return ContentPreviewApiFp(this.configuration).getContentPreview(contentId, version, options)(this.axios, this.basePath);
    }
}
exports.ContentPreviewApi = ContentPreviewApi;
